export const SEARCH_QUERY_KEY = 'query';
export const PAGE_QUERY_KEY = 'page';
